import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isApiLoading: false,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setApiLoading: (state, action) => {
      state.isApiLoading = action.payload;
    },
  },
});

export const { setApiLoading } = loadingSlice.actions;

export const selectIsApiLoading = (state) => state.loading.isApiLoading;

export default loadingSlice.reducer;
